export const adaptador_pedido_pago = (entidad) => {


    let arr = []

    let productos = entidad.productos

    let envio =
        {
            "id": 'Env001',
            "title": 'Pedido Nariño Souvenirs' + entidad.ciudad,
            "description": entidad.empresaEnvio,
            "category_id": 'servicios',
            "quantity": 1,
            "currency_id": "COP",
            "unit_price": entidad.valorEnvio
        }

    arr.push(envio)


    for (let prod of productos) {

        let i = 156132

        let obj =
            {
                "id": i++,
                "title": prod.nombre,
                "description": prod.descripcion,
                "category_id": prod.categoria,
                "quantity": prod.cantidad,
                "currency_id": "COP",
                "unit_price": prod.valor
            }

        arr.push(obj)
    }

    let obj = {
        "items": arr,
        "payer": {
            "name": entidad.nombres,
            "surname": entidad.apellidos,
            "email": entidad.correo,
            "phone": {
                "area_code": "57",
                "number": entidad.celular
            },
            "identification": {
                "type": "DNI",
                "number": entidad.cc
            },
            "address": {
                // "zip_code": "110221",
                // "street_name": "Example Street",
                // "street_number": 93
            }
        },
        "back_urls": {
            "success": "https://narinosouvenirs.com/Checkout",
            "failure": "https://narinosouvenirs.com/Checkout",
            "pending": "https://narinosouvenirs.com/Checkout"
        },
        "auto_return": "approved",
        "external_reference": entidad.id


    }

    return obj


}